// Formatting helpers shared across pages.

export const formatTaka = (amount) => `৳ ${Number(amount).toLocaleString("en-IN")}`;

export const formatPrice = (pkg) => `${formatTaka(pkg.price)} / ${pkg.unit === "visit" ? "Visit" : "Day"}`;

// "2026-01-12" -> "Jan 12, 2026" (same style as the original site)
export const formatDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

// "16:00" -> "4:00 PM"
export function formatTime(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  const suffix = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${suffix}`;
}

export const formatRange = (start, end) => `${formatTime(start)} – ${formatTime(end)}`;

export const telHref = (phone) => `tel:${phone}`;
export const whatsappHref = (number, text = "") =>
  `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const youtubeId = (url = "") => {
  const m = url.match(/(?:youtu\.be\/|v=|embed\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
};
